<template>
    <div>
        <div class="simple-row">
            <div class="left">
                <a class="swb-btn swb-btn-small" @click="toPrint">打印</a>
            </div>
        </div>
        <div class="content-caption dashed">
            <span>报废单信息</span>
            <div class="shrink-tab fr" :class="showScrapVoucherInfoFlag? 'current': ''" @click="doShowScrapVoucherInfo()">
                <span>{{ showScrapVoucherInfoFlag ? '隐藏' : '展开' }}</span>
                <i :class="showScrapVoucherInfoFlag? 'el-icon-arrow-down': 'el-icon-arrow-right'"></i>
            </div>
        </div>
        <template v-if="showScrapVoucherInfoFlag">
            <div class="simple-form flex col-4">
                <div class="form-group center">
                    <div class="form-label">
                        <label>报废单号</label>
                    </div>
                    <div class="form-value">
                        <span>{{ scrapVoucherInfo.innerNo || '' }}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>记账凭证号</label>
                    </div>
                    <div class="form-value">
                        <span>{{ scrapVoucherInfo.reservedNo || '无' }}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>报废总数量</label>
                    </div>
                    <div class="form-value">
                        <span>{{ scrapVoucherInfo.totalQuantity || 0 }}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>报废金额</label>
                    </div>
                    <div class="form-value">
                        <span>{{ scrapVoucherInfo.splittedAmount || 0.00 }} 元</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>申请人</label>
                    </div>
                    <div class="form-value">
                        <span>{{ scrapVoucherInfo.applicantName }}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>申请人电话</label>
                    </div>
                    <div class="form-value">
                        <span>{{ scrapVoucherInfo.applicantContactTel }}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>所属公司</label>
                    </div>
                    <div class="form-value">
                        <span>{{ scrapVoucherInfo.retailerRealComName }}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>所属机构</label>
                    </div>
                    <div class="form-value">
                        <span>{{ scrapVoucherInfo.comFullName }}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>机构编码</label>
                    </div>
                    <div class="form-value">
                        <span>{{ scrapVoucherInfo.bizUnitCode }}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>成本中心</label>
                    </div>
                    <div class="form-value">
                        <span>{{ scrapVoucherInfo.costCenterCode || '无' }}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>利润中心</label>
                    </div>
                    <div class="form-value">
                        <span>{{ scrapVoucherInfo.prftCenterCode || '无' }}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>创建时间</label>
                    </div>
                    <div class="form-value">
                        <span>{{ scrapVoucherInfo.createTime }}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>申请时间</label>
                    </div>
                    <div class="form-value">
                        <span>{{ scrapVoucherInfo.applyTime }}</span>
                    </div>
                </div>
                <!--<div class="form-group center">-->
                <!--<div class="form-label">-->
                <!--<label>生凭状态</label>-->
                <!--</div>-->
                <!--<div class="form-value">-->
                <!--<span>{{ledgerStateMap[scrapVoucherInfo.ledgerState]}}</span>-->
                <!--</div>-->
                <!--</div>-->
                <div class="form-group center">
                    <div class="form-label">
                        <label>生凭时间</label>
                    </div>
                    <div class="form-value">
                        <span>{{ scrapVoucherInfo.ledgerTime || '' }}</span>
                    </div>
                </div>
                <div class="form-group center" v-if="showBizUnitWarehouse">
                    <div class="form-label">
                        <label>报废仓库</label>
                    </div>
                    <div class="form-value">
                        <span>{{ scrapVoucherInfo.warehouseName }}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>申请原因</label>
                    </div>
                    <div class="form-value">
                        <span>{{ scrapVoucherInfo.applyDesc || '无' }}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>标题</label>
                    </div>
                    <div class="form-value">
                        <span>{{ scrapVoucherInfo.digest || '无' }}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>自动标记闲置</label>
                    </div>
                    <div class="form-value">
                        <span>{{ scrapVoucherInfo.autoMaskAsIdle ? '是' : '否' }}</span>
                    </div>
                </div>
            </div>
        </template>
        <div class="content-caption dashed">
            <span>资产信息</span>
            <div class="shrink-tab fr" :class="showDeviceItemFlag? 'current': ''" @click="doShowDeviceItem()">
                <span>{{ showDeviceItemFlag ? '隐藏' : '展开' }}</span>
                <i :class="showDeviceItemFlag? 'el-icon-arrow-down': 'el-icon-arrow-right'"></i>
            </div>
        </div>
        <template v-if="showDeviceItemFlag">
            <div class="table-layout">
                <el-table ref="multipleTable" :data="scrapItems" maxHeight="500" border tooltip-effect="dark" style="width: 100%">
                    <el-table-column align="left" prop="innerCode" min-width="180" fixed label="资产编号" show-overflow-tooltip>
                        <template slot-scope="rows">
                            <a class="table-cell-link" @click="viewAssetInfo(rows.row, rows.row.innerCode);">{{ rows.row.innerCode }}</a>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" prop="title" label="资产描述全称" width="180" fixed show-overflow-tooltip></el-table-column>
                    <el-table-column align="right" prop="quantity" width="100" label="报废数量"></el-table-column>
                    <el-table-column align="left" prop="splitible" width="100" label="控制方式">
                        <template slot-scope="rows">
                            <span>{{ rows.row.splitible ? '按金额' : '按数量' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="资产原值(元)" width="80" align="right">
                        <template slot-scope="rows">
                            <span v-if="rows.row.orgWorthKz != null">{{ rows.row.orgWorthKz.toFixed(2) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="资产净值(元)" width="80" align="right">
                        <template slot-scope="rows">
                            <span v-if="rows.row.netWorthKz != null">{{ rows.row.netWorthKz.toFixed(2) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="报废原值(元)" width="80" align="right">
                        <template slot-scope="rows">
                            <span v-if="rows.row.orgWorth != null">{{ rows.row.orgWorth.toFixed(2) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" width="80" label="报废金额(元)">
                        <template slot-scope="rows">
                            <span v-if="rows.row.netWorth != null">{{ rows.row.netWorth.toFixed(2) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" prop="durableLife" width="100" label="使用年限(月)"></el-table-column>
                    <el-table-column prop="fiscalInTime" label="入账时间" align="center">
                        <template slot-scope="rows">
                            <span v-if="rows.row.fiscalInTime != null">{{ rows.row.fiscalInTime }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" prop="scrapCause" min-width="150" label="报废原因">
                        <template slot-scope="rows">
                            <span>{{ devcScrapCauseMap[rows.row.scrapCause] }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" prop="innerNo" label="外部资产编码" width="180" show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" prop="staffName" width="120" label="报废人员"></el-table-column>
                    <el-table-column align="left" prop="comFullName" width="200" label="部门全称" show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" prop="costCenterCode" label="成本中心" width="120" show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" prop="departName" width="180" label="报废部门" show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" prop="fixedSpec" label="规格" width="180" show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" prop="assetNature" label="资产属性" width="100" show-overflow-tooltip>
                        <template slot-scope="rows">
                            <span v-if="rows.row.assetNature != null">{{ assetNatureMap[rows.row.assetNature] }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" prop="durableYears" width="100" label="已用年限(月)"></el-table-column>
                    <el-table-column align="center" prop="deprTiming" width="100" label="报废时效类型">
                        <template slot-scope="rows">
                            <span v-if="rows.row.deprTiming != null">{{ scrapDeprTimingMap[rows.row.deprTiming] }}</span>
                        </template>
                    </el-table-column>
                    <!--<el-table-column align="left" prop="memo" min-width="150" label="原因说明" show-overflow-tooltip></el-table-column>-->
                    <el-table-column align="left" prop="tmpNo" min-width="250" label="系统编号" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="assetType" width="100" label="管理方式" align="center">
                        <template slot-scope="rows">
                            <span>{{ assetTypeMap[rows.row.assetType] }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column prop="devcCustTag1Val" :label="devcCustTag1.dispName" width="120" v-if="devcCustTag1.enabled == true">
                    </el-table-column>
                    <el-table-column prop="devcCustTag2Val" :label="devcCustTag2.dispName" width="120" v-if="devcCustTag2.enabled == true">
                    </el-table-column>
                    <el-table-column prop="devcCustTag3Val" :label="devcCustTag3.dispName" width="120" v-if="devcCustTag3.enabled == true">
                    </el-table-column>

                    <el-table-column prop="theInc" width="150" label="清理收入" align="right">
                        <template slot-scope="rows">
                            <span v-if="rows.row.theInc != null">{{ rows.row.theInc.toFixed(2) }}</span>
                        </template>
                    </el-table-column>

                    <!--<el-table-column align="left" prop="reservedNo" min-width="250" label="记账凭证号" show-overflow-tooltip></el-table-column>-->
                    <template v-for="colNameX in colNames">
                        <el-table-column :label="colNameX" align="center" width="200" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <template v-if="scope.row.reservedNoJson != null" v-for="theJson in scope.row.reservedNoJson">
                                    <span v-if="theJson.text == colNameX">{{ theJson.value }}</span>
                                </template>
                            </template>
                        </el-table-column>
                    </template>
                </el-table>
            </div>
            <div class="pagination-layout">
                <el-pagination background :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange"
                               layout="total, sizes, prev, pager, next, jumper"></el-pagination>
            </div>
        </template>
        <div class="content-caption dashed" v-if="scrapVoucherInfo.scrapFileList != null && scrapVoucherInfo.scrapFileList.length > 0">
            <span>附件信息</span>
            <div class="shrink-tab fr" :class="showFileItemInfoFlag? 'current': ''" @click="doShowFileItemInfo()">
                <span>{{ showFileItemInfoFlag ? '隐藏' : '展开' }}</span>
                <i :class="showFileItemInfoFlag? 'el-icon-arrow-down': 'el-icon-arrow-right'"></i>
            </div>
        </div>
        <template v-if="showFileItemInfoFlag">
            <div class="file-view-list" v-if="scrapVoucherInfo.scrapFileList != null && scrapVoucherInfo.scrapFileList.length > 0">
                <div class="file-view-header">
                    <div class="file-name">名称</div>
                    <div class="file-opera">操作</div>
                </div>
                <template v-for="(fileInfo, index) in scrapVoucherInfo.scrapFileList">
                    <swb-file-item-li :trackKey="index" :fileName="fileInfo.name" :fileBrowseUrl="fileInfo.fileBrowseUrl" :fileDownloadUrl="fileInfo.fileBrowseUrl" :fileUuid="fileInfo.fileUuid" :deletable="false"></swb-file-item-li>
                </template>
            </div>
        </template>
        <template v-if="scrapVoucherInfo.outerAuditFlag">
            <div class="content-caption dashed">
                <span>审核记录</span>
                <div class="shrink-tab fr" :class="showOaAuditRecFlag? 'current': ''" @click="doShowOaAuditRec()">
                    <span>{{ showOaAuditRecFlag ? '隐藏' : '展开' }}</span>
                    <i :class="showOaAuditRecFlag? 'el-icon-arrow-down': 'el-icon-arrow-right'"></i>
                </div>
            </div>
            <template v-if="showOaAuditRecFlag">
                <swb-oa-audit-rec-list bizTypeCode="retailer.assets.scrap" :bizVoucherNo="scrapVoucherInfo.innerNo" :auditSeqNo="scrapVoucherInfo.auditSeqNo" ref="swb_oa_audit_rec_list"></swb-oa-audit-rec-list>
            </template>
        </template>
        <template v-if="!scrapVoucherInfo.outerAuditFlag && scrapVoucherInfo.no != null">
            <div class="content-caption dashed">
                <span>审核记录</span>
                <div class="shrink-tab fr" :class="showShopDeviceActFlag? 'current': ''" @click="doShowShopDeviceAct()">
                    <span>{{ showShopDeviceActFlag ? '隐藏' : '展开' }}</span>
                    <i :class="showShopDeviceActFlag? 'el-icon-arrow-down': 'el-icon-arrow-right'"></i>
                </div>
            </div>
            <template v-if="showShopDeviceActFlag">
                <swb-shop-device-act-rec-list :showQuery="false" :showComFlag="false" :srcVoucherNo="scrapVoucherInfo.no" :srcVoucherType="srcVoucherType" ref="swb_shop_device_act_rec_list"></swb-shop-device-act-rec-list>
            </template>
        </template>
    </div>
</template>

<script>
import { Utils } from '../../app.base'
import { Vue, MsgBox, Routes } from '../../app.vues'
import { getDefaultPageSizes } from '../../app.conf'
import { getDevcGroupNameByCatId } from '../index'
import { assetFiscalInfoDlg } from '../retailer/dialog'
import { getMerchantBizParam } from '../asset/assetMain'
import custTagMeataApi from '../../api/objTagConf';
import shopDeviceApi from '../../api/shopDevc'
import assetVchrApi from '../../api/assetVchr'
//
import SwbFileItemLi from '../ctrl/FileItemLi';

Vue.regist(SwbFileItemLi);

import AuditBpRecsList from '../oaAudit/AuditBpRecsList.vue';

Vue.regist(AuditBpRecsList);

import SwbShopDeviceRecList from '../retailer/ShopDeviceRecList.vue'

Vue.regist(SwbShopDeviceRecList);

export default {
    name: 'swb-shop-scrap-voucher-view',
    avlActions: '',
    avlScopes: 'vendor',
    notAsResc: true,
    authen: false,
    desc: '报废单制作',
    props: ['id', 'no'],
    data: function () {
        return {
            totalCount: 0,
            pageSize: null,
            pageSizes: getDefaultPageSizes(),
            pageNumber: 1,
            //
            scrapVoucherInfo: {},
            scrapItems: [],
            //
            devcScrapCauseMap: getEnumMap('devcScrapCause', 'value2text'),
            assetNatureMap: getEnumMap('assetNature', 'value2text'),
            ledgerStateMap: getEnumMap('ledgerState', 'value2text'),
            srcVoucherType: getEnumInfoWith('devcVoucherType', 'name', 'Scrap').value,
            assetTypeMap: getEnumMap('assetType', 'value2text'),
            scrapDeprTimingMap: getEnumMap('scrapDeprTiming', 'value2text'),
            showDeviceItemFlag: true,
            showScrapVoucherInfoFlag: true,
            showFileItemInfoFlag: true,
            showShopDeviceActFlag: true,
            showOaAuditRecFlag: true,
            colNames: [],
            devcCustTag1: {
                dispName: '自定义标签1',
                itemList: [],
                enabled: false,
                refUsed: false
            },
            devcCustTag2: {
                dispName: '自定义标签2',
                itemList: [],
                enabled: false,
                refUsed: false
            },
            devcCustTag3: {
                dispName: '自定义标签3',
                itemList: [],
                enabled: false,
                refUsed: false
            }
        }
    },
    created: function () {
        let self = this;
        self.getCustTagMetaFields();
        this.pageSize = this.pageSizes.first();
        //
        getMerchantBizParam('show.biz.unit.warehouse', function (result) { // 显示门店/机构的仓库： {}
            self.showBizUnitWarehouse = Utils.isTrue(result);
        });
        //
        this.getShopDeviceScrapVoucher();
    },
    methods: {
        getGoodsCatDevcGroupName: function (catId) {
            return getDevcGroupNameByCatId(catId);
        },
        getShopDeviceScrapVoucher: function () {
            let self = this;
            let postData = {};
            postData.id = self.id;
            postData.no = self.no;
            assetVchrApi.getShopDeviceScrapVoucher(postData, function (result) {
                if(result.type == 'info') {
                    let scrapVoucherInfo = result.data;
                    self.scrapVoucherInfo = Utils.merge({}, scrapVoucherInfo);
                    //
                    self.getShopDeviceScrapVoucherItems();
                } else {
                    MsgBox.warning(result.message);
                }
            })
        },

        handleSizeChange: function (val) {
            let curStartIndex = (this.pageNumber - 1) * this.pageSize;
            this.pageSize = val;
            let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
            this.handlePageChange(newPageNumber);
        },
        handlePageChange: function (val) {
            this.pageNumber = val;
            this.getShopDeviceScrapVoucherItems();
        },

        getShopDeviceScrapVoucherItems: function () {
            let self = this;
            let postData = {};
            postData.pagination = {
                pageSize: self.pageSize,
                pageNumber: self.pageNumber,
            };
            let filterItems = {};
            filterItems.voucherId = self.scrapVoucherInfo.id;
            postData.filterItems = filterItems;
            let theLoading = MsgBox.loading();
            assetVchrApi.getShopDeviceScrapItemList(postData, function (result) {
                theLoading.close();
                if(result.type === 'info') {
                    let data = result.data;
                    let rows = data.rows || [];
                    let colNames = [];
                    rows.forEach(function (item) {
                        let reservedNo = item.reservedNo;
                        if(!Utils.isNoB(reservedNo)) {
                            let reservedNoJson = JSON.decode(reservedNo);
                            let theNames = reservedNoJson.pluck('text');
                            colNames.add(Utils.compareArrays(theNames, colNames)['more']);
                            item.reservedNoJson = reservedNoJson;
                        }
                    });
                    self.colNames = colNames;
                    self.scrapItems = Utils.merge([], rows);
                    self.totalCount = data.pagination.totalCount;
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        // 查看资产信息
        viewAssetInfo: function (row, innerCode) {
            let params = {
                innerCode: innerCode,
                assetType: row.assetType
            };
            assetFiscalInfoDlg(params);
        },
        // 隐藏、展开
        doShowDeviceItem: function () {
            this.showDeviceItemFlag = !this.showDeviceItemFlag;
        },
        // 隐藏、展开
        doShowScrapVoucherInfo: function () {
            this.showScrapVoucherInfoFlag = !this.showScrapVoucherInfoFlag;
        },
        // 隐藏、展开
        doShowFileItemInfo: function () {
            this.showFileItemInfoFlag = !this.showFileItemInfoFlag;
        },
        // 隐藏、展开
        doShowShopDeviceAct: function () {
            this.showShopDeviceActFlag = !this.showShopDeviceActFlag;
        },
        // 隐藏、展开
        doShowOaAuditRec: function () {
            this.showOaAuditRecFlag = !this.showOaAuditRecFlag;
        },
        toPrint() {
            let collapsedBlocks = [];

            if(!this.showScrapVoucherInfoFlag) {
                collapsedBlocks.push('scrapVoucherInfo');
            }
            if(!this.showDeviceItemFlag) {
                collapsedBlocks.push('itemList');
            }
            if(!this.showFileItemInfoFlag) {
                collapsedBlocks.push('scrapFileList');
            }
            if(!this.showOaAuditRecFlag) {
                collapsedBlocks.push('oaRecList');
            }
            if(!this.showShopDeviceActFlag) {
                collapsedBlocks.push('actRecList');
            }
            let scrapVoucherInfo = this.scrapVoucherInfo;
            let url = '/voucher/print/jsp';
            let postData = {
                bizType: 'biz.proof.zichan.baofei',
                voucherId: scrapVoucherInfo.id,
                collapsedBlocks: collapsedBlocks.join(',')
            };
            let printUrl = Utils.makeUrl(getAppUrl(url), postData);
            Utils.setPageUrl(printUrl, '_blank');
        },
        getCustTagMetaFields: function () {
            let self = this
            let param = [{tagMetaTableName: 'shop_device', tagMetaRole: 1}]
            custTagMeataApi.getCustTagMetaFields(param, function (result) {
                if(result.type == 'info') {
                    let tags = result.data
                    for(let i = 0; i < tags.length; i++) {
                        let tag = tags[i]
                        if(tag.fieldName == 'devcCustTag1') {
                            self.devcCustTag1 = {
                                dispName: tag.dispName,
                                itemList: tag.itemList,
                                enabled: tag.enabled,
                                refUsed: tag.refUsed
                            }
                        } else if(tag.fieldName == 'devcCustTag2') {
                            self.devcCustTag2 = {
                                dispName: tag.dispName,
                                itemList: tag.itemList,
                                enabled: tag.enabled,
                                refUsed: tag.refUsed
                            }
                        } else if(tag.fieldName == 'devcCustTag3') {
                            self.devcCustTag3 = {
                                dispName: tag.dispName,
                                itemList: tag.itemList,
                                enabled: tag.enabled,
                                refUsed: tag.refUsed
                            }
                        }
                    }
                } else {
                    MsgBox.warning(result.message)
                }
            });
        }
    }
}
</script>

<style>
.form-info .form-row {
    height: 30px;
    line-height: 30px;
    margin-top: 6px;
    margin-bottom: 6px;
}
</style>



// WEBPACK FOOTER //
// src/compo/scrapVoucher/ShopDeviceScrapVoucherView.vue